<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <div 
    [class]="'active-input' + getDisabledClass()" 
    [class.error]="formControl.invalid">
      @for(checkboxOption of $any(field.props.options); track $index) {
        <div class="checkbox-item">
          <input
            type="checkbox"
            class="checkbox-input"
            [id]="'checkbox-' + field.key + '-' + checkboxOption.code"
            title="{{checkboxOption.label}}"
            [(ngModel)]="value[checkboxOption.code]"
            (ngModelChange)="onValueChange(checkboxOption.code, $event)"
          />
          <label
            class="checkbox-label"
            [for]="'checkbox-' + field.key + '-' + checkboxOption.code"
          >
            <span class="text">{{checkboxOption.label | translate}}</span>
          </label>
        </div>
      }
    </div>
  } @else {
    <div class="disabled-result" [class.non-compact]="!options.formState.showCompactViewWhenDisabled">
      {{getSelectedItemsAsText()}}
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>